import React from 'react'
import CasesAnalytics from './CasesAnalytics';
import AllCaseList from './AllCaseList';
import { AdminPage, ViewSwitch, useViewParam } from './AdminAnalyticsUI';

// Design 19a / 19d - "Cases analytics" and "Cases list" share this shell.
// The active view lives in the URL (?view=analytics | ?view=list).
const VIEWS = [
  { key: 'analytics', label: 'Cases analytics' },
  { key: 'list', label: 'Cases list' },
];

function AnalyticsCases({setActivePanel, activePanel}) {
  const [view, setView] = useViewParam();
  const viewSwitch = <ViewSwitch options={VIEWS} value={view} onChange={setView} />;

  return (
    <AdminPage setActivePanel={setActivePanel} activePanel={activePanel}>
      {view === 'analytics' ?
        <>
          <div style={{ marginBottom: '26px' }}>{viewSwitch}</div>
          <CasesAnalytics />
        </>
        :
        <AllCaseList viewSwitch={viewSwitch} />
      }
    </AdminPage>
  )
}

export default AnalyticsCases
